import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import 'ag-grid-enterprise'
import { AgGridReact } from 'ag-grid-react'
import { deleteSkill } from '../../../actions/competences/skills/skilldelete'
import { getSkill } from '../../../actions/competences/skills/skillget'
import { postSkill } from '../../../actions/competences/skills/skillpost'
import { getAllSkillsForPerson } from '../../../actions/competences/skills/skillsgetallforperson'
//import { getAllSkillsForPersonModified } from "../../../actions/competences/skills/skillsgetallforpersonmodified";
import { getAllSkillsForPersons } from '../../../actions/competences/skills/skillsgetallforpersons'
//import { getAllSkillsModified } from "../../../actions/competences/skills/skillsgetallmodified";
import { addGridData, getLocaleText, removeGridData, resetSorting, updateGridData } from '../../../actions/datagrid'
import { Button } from '../../../common/Button.tsx'
import {
	contextMenu,
	defaultColDef,
	gridSettings,
	loadViewState,
	restoreViewState,
	saveViewState,
	sideBar,
	statusBar,
} from '../../../common/grid'
import {
	IconAddNew,
	pencilIconString,
	restoreIconString,
	TemplateProfileImage,
	trashIconString,
} from '../../../common/icons'
import { PdfReport } from '../../../common/pdfreport'
import { fetchSettings } from '../../../common/settings.js'
import { starFormatter, tagFormatter /*useInterval*/ } from '../../../common/utils'
import {
	actionTypeSelector,
	authSelector,
	skillSelector,
	/*skillsModifiedSelector,*/
	skillsSelector,
} from '../../../reducers'
import { AddSkill } from './skillmodal'

const viewStateKey = 'skillsViewState'

export default function SkillsView({ person }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const path = window.location.pathname
	const isPersonal = path.startsWith('/personal')

	const actionType = useSelector(actionTypeSelector)
	const { admin, companyName } = useSelector(authSelector)
	const skills = useSelector(skillsSelector)
	const skill = useSelector(skillSelector)

	const [settings, setSettings] = useState({})

	const [report, setReport] = useState(null)
	const closeReport = () => setReport(null)

	const [modalShow, setModalShow] = useState(false)
	const [showLoading, setShowLoading] = useState(false)

	const gridRef = useRef()

	useEffect(() => {
		if (!person && !isPersonal) {
			dispatch(getAllSkillsForPersons(true))
		}
		return () => dispatch({ type: 'SKILLS_UNMOUNT', payload: { skills: null, skill: null } })
	}, [person, isPersonal, dispatch])

	useEffect(() => {
		if (person) {
			if (person?.personId) {
				dispatch(getAllSkillsForPerson(person?.personId))
			}
		}
	}, [person, dispatch])

	useEffect(() => {
		;(async () => {
			setSettings(await fetchSettings())
		})()
	}, [])
	/*
	const fetchModifiedSkills = useCallback((modifiedSince) => dispatch(getAllSkillsModified(modifiedSince)));
	const fetchModifiedSkillsForPerson = useCallback((personId, modifiedSince) =>
		dispatch(getAllSkillsForPersonModified(person?.personId, modifiedSince)),
	);
  const [modifiedSince, setModifiedSince] = useState(Date.now());
  if (import.meta.env.TEST) {
    // production
    // Poll modified skills every 30 seconds
    useInterval(() => {
      const tmpModifiedSince = modifiedSince;
      setModifiedSince(Date.now());
      if (person?.personId) {
        fetchModifiedSkillsForPerson(person?.personId, tmpModifiedSince);
      } else {
        fetchModifiedSkills(tmpModifiedSince);
      }
    }, 30 * 1000);
  }
  const skillsModified = useSelector(skillsModifiedSelector)
  useEffect(() => {
		if (gridRef.current.api) {
			if (skillsModified?.newSkills?.length > 0) {
				addGridData(gridRef, skillsModified.newSkills, 0)
			}
			if (skillsModified?.modifiedSkills?.length > 0) {
				updateGridData(gridRef, skillsModified.modifiedSkills)
			}
			if (skillsModified?.deletedSkills?.length > 0) {
				removeGridData(gridRef, skillsModified.deletedSkills)
			}
		}
	}, [skillsModified])
*/
	useEffect(() => {
		if (actionType.endsWith('_LOADING')) {
			setShowLoading(true)
		} else if (actionType.endsWith('_SUCCEEDED') || actionType.endsWith('_FAIL') || actionType.endsWith('_DONE')) {
			setShowLoading(false)
		}
		if (actionType === 'POST_SKILL_SUCCEEDED') {
			resetSorting(gridRef)
			addGridData(gridRef, [skill], 0)
		}
		if (actionType === 'POST_SKILL_EDIT_SUCCEEDED') {
			updateGridData(gridRef, [skill])
		}
		if (actionType === 'UPLOAD_DONE') {
			person?.personId ? dispatch(getAllSkillsForPerson(person?.personId)) : dispatch(getAllSkillsForPersons(true))
			setModalShow(false)
		}
		if (actionType === 'GET_SKILL_SUCCEEDED') {
			setModalShow(true)
		}
		if (actionType === 'DELETE_SKILL_SUCCEEDED') {
			removeGridData(gridRef, [skill])
		}
	}, [actionType, skill, dispatch, person])

	const saveData = (data) => dispatch(postSkill(data))

	const removeSkill = useCallback(
		({ id, data: { personName } }) => {
			if (confirm(`${t('DeleteSkillConfirm', 'Haluatko varmasti poistaa taidon?')} (${personName})`)) {
				dispatch(deleteSkill(id))
			}
		},
		[dispatch, t],
	)

	const gridComponents = {
		templateProfileImage: TemplateProfileImage,
	}

	const columnDefs = useMemo(
		() => [
			{
				headerName: t('Number', 'Numero'),
				field: 'personNumber',
				filter: 'agNumberColumnFilter',
				suppressSizeToFit: true,
				minWidth: 115,
				maxWidth: 115,
				width: 115,
				hide: !!(isPersonal || !!person),
			},
			{
				headerName: t('Name', 'Nimi'),
				field: 'personName',
				width: 150,
				hide: !!(isPersonal || !!person),
			},
			{
				headerName: t('Skill', 'Taito'),
				field: 'skillCodeItem.codeValue',
				width: 125,
			},
			{
				headerName: t('SkillLevel', 'Osaamistaso'),
				field: 'skillLevel',
				valueFormatter: starFormatter,
			},
			{
				headerName: t('Description', 'Selite'),
				field: 'skillDescription',
				tooltipField: 'skillDescription',
			},
			{
				headerName: t('Memo', 'Muistio'),
				field: 'skillMemo',
				tooltipField: 'skillMemo',
			},
			{
				field: 'supervisor',
				headerName: t('Supervisor', 'Esihenkilö'),
			},
			{
				field: 'supervisor2',
				headerName: `${t('Supervisor', 'Esihenkilö')} 2`,
			},
			{
				field: 'dim1',
				headerName: settings.dim1name || t('Dimension1', 'Kustannuspaikka'), // costUnitName
			},
			{
				field: 'dim2',
				headerName: settings.dim2name || t('Dimension2', 'Projekti'), // projectName
			},
			{
				field: 'dim3',
				headerName: settings.dim3name || t('Dimension3', 'Dimensio 3'),
			},
			{
				field: 'dim4',
				headerName: settings.dim4name || t('Dimension4', 'Dimensio 4'),
			},
			{
				field: 'dim5',
				headerName: settings.dim5name || t('Dimension5', 'Dimensio 5'),
			},
			{
				field: 'dim6',
				headerName: t('BusinessId', 'Y-tunnus'),
			},
			{
				headerName: t('Keywords', 'Avainsanat'),
				field: 'tags',
				valueGetter: (params) => tagFormatter(params.data?.tags),
				tooltipValueGetter: (params) => tagFormatter(params.data?.tags),
				hide: !!(isPersonal || !!person),
			},
		],
		[t, settings, person, isPersonal],
	)

	const initialState = useMemo(
		() => ({
			columnVisibility: {
				...(isPersonal || person
					? { hiddenColIds: ['personNumber', 'personName', 'tags'] }
					: { hiddenColIds: ['supervisor', 'supervisor2'] }),
			},
		}),
		[isPersonal, person],
	)

	const getContextMenuItems = useCallback(
		(params) => {
			let items = []

			if (!isPersonal) {
				items.push({
					name: t('DefaultGridValues', 'Palauta taulukon oletusasetukset'),
					action: () => {
						restoreViewState(viewStateKey, initialState)
					},
					icon: restoreIconString,
				})

				items.push('separator')
			}

			if (!params.api.isPivotMode()) {
				items.push({
					name: t('Edit', 'Muokkaa'),
					icon: pencilIconString,
					action: () => dispatch(getSkill(params.node.id)),
				})

				if (admin) {
					items.push({
						name: t('Delete', 'Poista'),
						icon: trashIconString,
						action: () => removeSkill(params.node),
					})
				}
				items.push('separator')
			}
			items = items.concat(
				contextMenu(t, params, setReport, {
					title: t('Skills', 'Taidot'),
					companyname: companyName,
				}),
			)
			return items
		},
		[companyName, dispatch, admin, isPersonal, t, removeSkill, initialState],
	)

	const doubleClickAction = (row) => !Number.isNaN(Number(row.node.id)) && dispatch(getSkill(row.node.id))

	return (
		<>
			{report !== null && <PdfReport json={report} onCloseReport={closeReport} />}

			{modalShow && <AddSkill show setShow={setModalShow} skillData={skill} saveData={saveData} />}
			{!location.pathname.startsWith('/mgmt/persons') && (
				<Row>
					<Col sm="4"></Col>
					<Col sm="8" align="right">
						<Row className="g-2">
							<Col />
							<Col md="auto">
								<Button
									className="competencebtn addbutton"
									onClick={() => {
										// empty fields when creating new
										dispatch({
											type: 'SKILL_UNMOUNT',
											payload: {
												skill: {
													skillId: 0,
													personId: person?.personId,
													personNumber: person?.nr,
													personName: person?.name,
												},
											},
										})
										setModalShow(true)
									}}
								>
									<IconAddNew /> {t('AddSkill', 'Lisää taito')}
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
			<Row className="ag-theme-material styles-ag flex-grow-1">
				<AgGridReact
					{...gridSettings}
					loading={showLoading}
					ref={gridRef}
					components={gridComponents}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					sideBar={sideBar}
					rowData={skills}
					getContextMenuItems={getContextMenuItems}
					statusBar={statusBar}
					onRowDoubleClicked={doubleClickAction}
					getRowId={(params) => String(params.data.skillId)}
					getLocaleText={(params) => getLocaleText(t, params)}
					animateRows
					suppressCellFocus
					enableCellTextSelection
					initialState={isPersonal || person ? initialState : loadViewState(viewStateKey)}
					onStateUpdated={({ state }) => !isPersonal && saveViewState(state, viewStateKey)}
					debug={import.meta.env.DEV}
				/>
			</Row>
		</>
	)
}
